import { useEffect } from 'react';

import { useUserStore } from '../stores';

export const useInitialCheckAuthentication = () => {
  const { hydrateFromStorage, setInitializing } = useUserStore();

  return useEffect(() => {
    setInitializing(true);
    hydrateFromStorage();
    setInitializing(false);
  }, [hydrateFromStorage, setInitializing]);
};
